// redirection url in case of inactive user attempting SSO login
export const OKTA_ORGANIZATION_URL = "https://dev-629020.okta.com";
export const AZURE_ORGANIZATION_URL = "https://account.activedirectory.windowsazure.com/?tenantid=6c262348-e294-48be-bc2f-64c88baa0e39";



// WEBPACK FOOTER //
// ./src/constants/sso.constants.js